// @flow
import type { Resource } from '@gandi/resource/redux';

import { useAppSelector } from 'src/hooks/useAppSelector';

export type ResourceStatuses = {
  isFailure: boolean,
  isFailure403: boolean,
  isFailure404: boolean,
  isFetching: boolean,
  isLoaded: boolean,
  isToRefetch: boolean,
  shouldFetch: boolean,
};

/**
 * Will just return the statuses for the given resource and label.
 */
export function useResourceListStatuses(
  resource: Resource<>,
  label: string,
): ResourceStatuses {
  const isFailure = useAppSelector(state =>
    resource.selectIsFailure(state, label),
  );
  const isFailure403 = useAppSelector(state =>
    resource.selectIsFailure(state, { label, status: 403 }),
  );
  const isFailure404 = useAppSelector(state =>
    resource.selectIsFailure(state, { label, status: 404 }),
  );
  const isFetching = useAppSelector(state =>
    resource.selectIsFetching(state, label),
  );
  const isLoaded = useAppSelector(state =>
    resource.selectIsLoaded(state, label),
  );
  const isToRefetch = useAppSelector(state =>
    resource.selectIsToRefetch(state, label),
  );
  const shouldFetch = useAppSelector(state =>
    resource.selectShouldFetch(state, label),
  );
  return {
    isFailure,
    isFailure403,
    isFailure404,
    isFetching,
    isLoaded,
    isToRefetch,
    shouldFetch,
  };
}

/**
 * Will just return the statuses for the given resource and label.
 */
export function useResourceOneStatuses(
  resource: Resource<>,
  label: string,
): ResourceStatuses {
  const isFailure = useAppSelector(state =>
    resource.selectIsFailureOne(state, label),
  );
  const isFailure403 = useAppSelector(state =>
    resource.selectIsFailureOne(state, { label, status: 403 }),
  );
  const isFailure404 = useAppSelector(state =>
    resource.selectIsFailureOne(state, { label, status: 404 }),
  );
  const isFetching = useAppSelector(state =>
    resource.selectIsFetchingOne(state, label),
  );
  const isLoaded = useAppSelector(state =>
    resource.selectIsLoadedOne(state, label),
  );
  const isToRefetch = useAppSelector(state =>
    resource.selectIsToRefetchOne(state, label),
  );
  const shouldFetch = useAppSelector(state =>
    resource.selectShouldFetchOne(state, label),
  );

  return {
    isFailure,
    isFailure403,
    isFailure404,
    isFetching,
    isLoaded,
    isToRefetch,
    shouldFetch,
  };
}
